module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/transform.js
// module id = 758
// module chunks = 0